import auth from './modules/auth'
import election from './modules/election'
import master from './modules/master'
import candidate from './modules/candidate'
import campaign from './modules/campaign'
import recap from './modules/recap'

export default {
  auth,
  election,
  master,
  candidate,
  campaign,
  recap
}
